<script>
import { useUserStore } from '@/store/user';
import BottomNavBar from "./BottomNavBar.vue";
import BottomNavItem from "./BottomNavItem.vue";


export default {
    name:"BottomBar",
    components: {
        BottomNavBar,
        BottomNavItem
    },    
    setup() {
        const userStore = useUserStore();

        return  { userStore }
    },
    beforeMount() {

        let userType = this.userStore.getUser.type;

        if (userType == "Professional") {
            this.itemsList = [
                {icon:"home", description:"Home", link:"/", active: this.thisIsTheCurrentPage("/")},
                {icon:"users", description:"Pacientes", link:"/patients", active: this.thisIsTheCurrentPage("/patients") },                
                {icon:"calendar", description:"Agenda", link:"/schedulings", active: this.thisIsTheCurrentPage("/schedulings")},
                // {icon:"notification", description:"Notificações", link:"/appNotifications", active: this.thisIsTheCurrentPage("/appNotifications")},                                
                {icon:"gear", description:"Perfil", link:"/configs", active: this.thisIsTheCurrentPage("/configs")},
            ]
        }
        else if (userType == "Patient") {
             this.itemsList = [
                {icon:"book", description:"Relatos", link:"/reports", active: this.thisIsTheCurrentPage("/reports") },                
                {icon:"calendar", description:"Agendamentos", link:"/myschedulings", active: this.thisIsTheCurrentPage("/myschedulings")},
                {icon:"notification", description:"Notificações", link:"/appNotifications", active: this.thisIsTheCurrentPage("/appNotifications")},
                {icon:"gear", description:"Perfil", link:"/configs", active: this.thisIsTheCurrentPage("/configs")},
            ]
        }

    },
    data() {
        return {
            itemsList:[]
        }
    },
    methods: {
        thisIsTheCurrentPage(path) {
            return path == this.$route.path ? true : false;
        }
    }
}
</script>

<template>
    <bottom-nav-bar>
        <template v-for="(item, index)  in itemsList" :key="index">
            <bottom-nav-item :link="item.link" :active="item.active">                                
                <template v-slot:icon>
                    <font-awesome-icon
                     :icon="['fas', item.icon]"
                      class="blue fs-5"
                      v-if="item.icon != 'notification'"
                      />                    
                    <app-notification class="blue fs-5" v-else />
                </template>
                <template v-slot:description>
                    <small class="blue fw-bold">
                        {{item.description}}
                    </small>
                </template>                    
            </bottom-nav-item>        
        </template>
    </bottom-nav-bar>
</template>

